const getLeadsWidgets = (ctx) => {
  return {
    name: '',
    widgets: [
      {
        icon: 'ListIcon',
        code: 'successRate',
        name: ctx.$t('totalLeadsByPeriod'),
        color: "warning",
        delimited: false,
        symbol: '',
        type: 'totalLeadsByPeriod',
        data: null
      },
      {
        icon: 'ListIcon',
        code: 'successRate',
        name: ctx.$t('totalPayedLeadsByPeriod'),
        color: "warning",
        delimited: false,
        symbol: '',
        type: 'totalPayedLeadsByPeriod',
        data: null
      },
      {
        icon: 'ListIcon',
        code: 'successRate',
        name: ctx.$t('conversionPercent'),
        color: "warning",
        delimited: false,
        symbol: '%',
        type: 'conversionPercent',
        data: null
      }
    ]
  }
}

export default getLeadsWidgets